import { SamdAppRepository } from '@samd/api/app_repository';
import {
  BuildVersionsFieldsFragment,
  OrganizationFieldsFragment,
  OrganizationWorkflowType,
  RoleFieldsFragment,
} from 'src/types';

const defaultOrganization: OrganizationFieldsFragment = {
  id: 'org-id',
  name: 'org-name',
  displayName: 'Org Name',
  workflowType: OrganizationWorkflowType.Clinic,
  features: {
    isInternational: false,
    allowTStageNotProvided: false,
  },
};

/**
 * Implementation of the App Repository for the Samd platform on a fake backend.
 */
export class SamdFakeAppRepository implements SamdAppRepository {
  async getEffectiveOrganization(): Promise<OrganizationFieldsFragment> {
    return defaultOrganization;
  }

  async getAssignableRoles(): Promise<RoleFieldsFragment[]> {
    return [];
  }

  async fetchBuildVersions(): Promise<BuildVersionsFieldsFragment> {
    return {
      ui: 'FAKE_UI',
      backend: 'FAKE_BACKEND',
      slidePreprocessor: 'FAKE_SLIDE_PREPROCESSOR',
      aiExecutor: 'FAKE_AI_EXECUTOR',
      prostatePrognosticModel: 'FAKE_PROSTATE_PROGNOSTIC_MODEL',
      breastPrognosticModel: 'FAKE_BREAST_PROGNOSTIC_MODEL',
      prostateSTADTModel: 'FAKE_PROSTATE_STADT_MODEL',
    };
  }
}
